<template>
  <div class="modal fade" id="remove-waste" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="modal-block-vcenter" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="block block-themed block-transparent mb-0">
          <div class="block-header bg-primary">
            <h3 class="block-title"><i class="fa fa-times"></i> Remove waste</h3>
            <div class="block-options">
              <button type="button" @click.prevent="clearData()" class="btn-block-option" data-dismiss="modal" aria-label="Close">
              <i class="fa fa-fw fa-times"></i>
              </button>
            </div>
          </div>
          <transition name="slide-fade">
            <div class="text-center alert-message-top" v-if="errorMsg">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div class="alert-message alert-danger alert-error-message">{{errorMsg}}</div>
              </div>
            </div>
          </transition>
          <div class="block-content">
            <div class="form-group required">
              <label class="control-label">Waste Type</label>
              <select id="remove-waste-type" placeholder="Select Waste Type.." class="form-control select2-dropdown" style="width: 100%;">
                <option></option>
                <option v-for="(wasteType, index) in library.wasteTypes" :key="index" :bind:value="wasteType.Name">{{ wasteType.Name }}</option>
              </select>
              <p v-if="wasteTypeError" class="errorMsg">The Waste Type field is required.</p>
            </div>
            <div class="form-group required">
              <label class="control-label">Unit Of Weight</label>
              <select id="remove-waste-measurement" placeholder="Select Unit Of Weight.." class="form-control select2-dropdown" style="width: 100%;">
                <option></option>
                <option v-for="(unit, index) in library.unitOfMeasurement" :key="index" :bind:value="unit.Name">{{ unit.Name }}</option>
              </select>
              <p v-if="wasteWeightError" class="errorMsg">The Unit Of Weight field is required.</p>
            </div>
            <div class="form-group">
              <label>Waste Weight</label>
              <input v-model="wasteWeight" type="number" min="1" oninput="validity.valid||(value='');" class="form-control form-control-alt" placeholder="Waste Weight">
            </div>
            <div class="form-group">
              <label>Actual Date</label>
              <input type="text" id="remove-waste-date" v-model="date" class="form-control form-control-alt datepicker" placeholder="Actual Date">
            </div>
          </div>
          <div class="block-content block-content-full text-right border-top button-loader">
            <button type="button" class="btn btn-sm btn-light" data-dismiss="modal" @click.prevent="clearData()">Close</button>
            <button type="button" class="btn btn-sm btn-primary" @click="removeWaste" :bind:disabled="showModalLoader">
              <div><i class="fa fa-save mr-1"></i><span>Save</span></div>
              <span class="modal-loader" v-if="showModalLoader">
                <hash-loader class="custom-class text-white" color="#fff" loading="loading" size="15" sizeUnit="px"></hash-loader>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import { mapState } from 'vuex';
import { VueSpinners, HashLoader } from '@saeris/vue-spinners';
import { helper } from '@/helper.js';
import $ from 'jquery';
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker3.min.css';
Vue.use(VeeValidate, VueSpinners);

export default {
  name: 'CreatePackageFromHarvest',
  data() {
    return {
      id: 0,
      wasteType: '',
      unitOfWeight: '',
      wasteWeight: 1,
      date: new Date().toJSON().slice(0,10),
      typeError: false,
      errorMsg: '',
      wasteTypeError: false,
      wasteWeightError: false,
      showModalLoader: false  
    };
  },
  mounted() {
    let vm = this;
    $('.datepicker').datepicker({ format: 'yyyy-mm-dd', autoclose:true });
    $('#remove-waste-measurement').on('change', function () { vm.wasteWeightError = false; vm.unitOfWeight = $(this).val();} );
    $('#remove-waste-type').on('change', function () { vm.wasteTypeError = false; vm.wasteType = $(this).val();} );
    $('#remove-waste-date').change(function() { vm.date = $(this).val(); });
  },
  component: {
    HashLoader
  },
  computed: {
    ...mapState({
      library: state => state.library
    })
  },
  methods: {
    removeWaste() {
      let vm = this;
      this.$validator.validate().then(valid => {
        if (vm.validate() && valid) {
          vm.showModalLoader = true;
          vm.errorMsg = '';
          helper.sendPostRequest('/harvests/removewaste',
            {
              'Id': vm.id,
              'WasteType': vm.wasteType,
              'UnitOfWeight': vm.unitOfWeight,
              'WasteWeight': vm.wasteWeight,
              'ActualDate': vm.date
            }
          ).then((data) => {
            if (data.status === 'success') {
              jQuery('#remove-waste').modal('hide');
              vm.$emit('loadHarvest', true);
              vm.showModalLoader = false;
              vm.clearData();
              helper.showSuccessModal(data.message);
            } else {
              vm.errorMsg = data.message;
              vm.showModalLoader = false;
            }
          });
        }
      });
    },
    clearData() {
      this.id = 0;
      this.wasteType = '';
      this.unitOfWeight = '';
      this.errorMsg = '';
      this.wasteWeight = 1;
      this.wasteTypeError = false;
      this.wasteWeightError = false;
      this.date = new Date().toJSON().slice(0,10);
      $('.select2-dropdown').val(null).trigger('change');
      $('.datepicker').datepicker('update', this.date);
      this.$validator.reset();
    },
    validate() {
      if (!this.wasteType) {
        this.wasteTypeError = true;    
      }

      if (!this.unitOfWeight) {
        this.wasteWeightError = true;    
      }

      if (this.wasteTypeError || this.wasteWeightError) {
        return false;
      }

      return true;
    }
  }
};
</script>


// WEBPACK FOOTER //
// source/components/modals/RemoveWaste.vue